import styled from 'styled-components'

export const Container = styled.div`
  svg,
  path {
    color: ${props => props.color};
    fill: ${props => props.color};
  }
`
